import React from 'react'
import { useNavigate } from 'react-router-dom'


type Props = {}

const PrivacyPolicy = (props: Props) => {
    const navigate = useNavigate()
    return (
        <div className="max-w-3xl mx-auto p-6 text-gray-800">
            <h3 className="w-full text-right cursor-pointer text-gray-700 hover:text-blue-500 hover:underline transition duration-200 ease-in-out" onClick={() => navigate("/")}>About</h3>
            <h1 className="text-3xl font-bold text-center mb-6">Privacy Policy</h1>

            <p className="mb-4">
                Welcome to <span className="font-semibold">Toctic</span>! Your privacy is important to us, and we’re committed to keeping your personal data safe while delivering the best short-video experience possible.
            </p>

            <h2 className="text-xl font-semibold mt-6">What Information We Collect</h2>
            <ul className="list-disc list-inside space-y-2 mt-2">
                <li><span className="font-semibold">Account Information:</span> Username, profile picture, bio, and other details you choose to share.</li>
                <li><span className="font-semibold">Content Data:</span> Videos you upload, likes, comments, and shares.</li>
                <li><span className="font-semibold">Usage Data:</span> How you interact with videos, trends, and other features.</li>
                <li><span className="font-semibold">Device & Technical Data:</span> IP address, device type, operating system, and app performance metrics.</li>
                <li><span className="font-semibold">Third-Party Logins:</span> If you sign in using Google, Apple, or Facebook, we may collect basic profile info.</li>
            </ul>

            <p className="mt-4 text-red-500 font-semibold">🚫 We DO NOT track or store your location data.</p>

            <h2 className="text-xl font-semibold mt-6">How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Personalize your <span className="font-semibold">For You</span> feed with trending and relevant content.</li>
                <li>Improve app performance, security, and user experience.</li>
                <li>Show you better recommendations and suggested content.</li>
                <li>Keep the community safe by enforcing our guidelines and policies.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">Third-Party Services</h2>
            <p className="mt-2">Toctic partners with trusted third-party services to enhance performance, analytics, and security:</p>
            <ul className="list-disc list-inside space-y-2 mt-2 text-blue-500">
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
                <li><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></li>
                <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase Crashlytics</a></li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">Your Choices & Control</h2>
            <ul className="list-disc list-inside space-y-2 mt-2">
                <li><span className="font-semibold">Editing or Deleting Data:</span> Update or delete your content anytime from your profile settings. To delete your account, contact <a href="mailto:brian@simationstudios.com" className="text-blue-500">brian@simationstudios.com</a>.</li>
                <li><span className="font-semibold">Opting Out:</span> Don't want us to collect data? You can uninstall the app at any time.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">Children’s Privacy</h2>
            <p className="mt-2">Toctic is <span className="font-semibold">not intended for users under 13</span>. If you're a parent or guardian and believe your child has shared personal data with us, contact us immediately.</p>

            <h2 className="text-xl font-semibold mt-6">Security Measures</h2>
            <p className="mt-2">We use encryption, secure servers, and other industry-standard measures to protect your data from unauthorized access.</p>

            <h2 className="text-xl font-semibold mt-6">Changes to This Policy</h2>
            <p className="mt-2">We may update this Privacy Policy from time to time. Check back regularly for updates.</p>

            <h2 className="text-xl font-semibold mt-6">Contact Us</h2>
            <p className="mt-2">Got questions about privacy? Reach out to us at <a href="mailto:brian@simationstudios.com" className="text-blue-500">brian@simationstudios.com</a>.</p>
        </div>
    )
}

export default PrivacyPolicy